export default function(value) {
    if (value.toString().length === 4) {
        return `0${value}`;
    }
    return value;
}
